export default "__VITE_ASSET__C$QDX3Gs__"